import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const BonusSection = () => {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    num: 1,
    title: '10 Ganchos de Contenido',
    value: '$12.000 ARS',
    desc: '10 formatos de publicación listos para usar en Instagram y LinkedIn que atraen consultas sin invertir un peso en publicidad. Copiás el formato, lo adaptás a tu rubro en 5 minutos y publicás.',
    target: 'Para el profesional que quiere generar presencia sin saber de marketing.',
    img: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&q=80&w=600'
  }, {
    num: 2,
    title: 'Pack Reactivación de Muertos',
    value: '$18.000 ARS',
    desc: '25 mensajes probados para WhatsApp, Instagram DM y LinkedIn. Divididos en 4 categorías: ex-clientes, presupuestos fantasma, leads fríos y seguimiento. No pensás qué escribir. Elegís, personalizás en 30 segundos y mandás.',
    target: 'Para el profesional que tiene contactos pero no sabe cómo reactivarlos sin incomodar.',
    img: 'https://images.unsplash.com/photo-1611262588024-d12430b98920?auto=format&fit=crop&q=80&w=600'
  }, {
    num: 3,
    title: 'Matriz de Oferta Anti-Crisis',
    value: '$15.000 ARS',
    desc: 'La plantilla paso a paso para crear versiones básica, recomendada y premium de tu servicio. Incluye la fórmula de la promesa irresistible, el sistema de anclaje de precio y las 3 opciones de reducción de riesgo.',
    target: 'Para el profesional que quiere dejar de cotizar de memoria y vender con estructura.',
    img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=600'
  }, {
    num: 4,
    title: 'Guion de Cierre Anti "No hay Plata"',
    value: '$20.000 ARS',
    desc: 'Los guiones específicos para cerrar cuando el cliente dice "no tengo plata", "es caro", "dejame pensarlo", "ahora no es el momento" o "lo voy a hacer yo". Más los 3 cierres finales para cuando hay intención pero duda.',
    target: 'Para el profesional que pierde ventas en el momento final por no saber qué decir.',
    img: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&q=80&w=600'
  }];
  return <section className="py-24 bg-cream" data-id="element-18">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-21">
            Y eso es solo el manual. También recibís:
          </h2>
        </div>

        <div className="space-y-12" data-id="element-22">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl overflow-hidden border border-neutral-200 shadow-sm flex flex-col md:flex-row" data-id="element-23">
              <div className="md:w-2/5 relative cursor-pointer group overflow-hidden" onClick={scrollToCompra} data-id="element-24">
                <div className="absolute top-4 left-4 z-20" data-id="element-25">
                  <span className="bg-brand-600 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow-md" data-id="element-26">
                    GRATIS POR EL DÍA DE HOY
                  </span>
                </div>
                <div className="absolute inset-0 bg-brand-600/10 group-hover:bg-transparent transition-colors z-10" data-id="element-27" />
                <img src={bonus.img} alt={bonus.title} className="w-full h-64 md:h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-28" />
              </div>

              <div className="p-8 md:w-3/5 flex flex-col justify-center" data-id="element-29">
                <div className="flex flex-wrap items-center gap-3 mb-4" data-id="element-30">
                  <span className="text-2xl" data-id="element-31">🎁</span>
                  <h3 className="text-2xl font-bold text-neutral-900" data-id="element-32">
                    BONUS {bonus.num} — {bonus.title}
                  </h3>
                </div>
                <div className="mb-6 inline-block" data-id="element-33">
                  <span className="bg-cream text-neutral-700 text-sm font-semibold px-3 py-1 rounded-md border border-neutral-200" data-id="element-34">
                    Valor:{' '}
                    <span className="line-through opacity-70" data-id="element-35">
                      {bonus.value}
                    </span>{' '}
                    <span className="text-brand-600 ml-1" data-id="element-36">GRATIS</span>
                  </span>
                </div>
                <p className="text-neutral-600 text-lg mb-6 leading-relaxed" data-id="element-37">
                  {bonus.desc}
                </p>
                <div className="bg-cream p-4 rounded-lg border-l-4 border-brand-500" data-id="element-38">
                  <p className="text-brand-700 font-medium m-0 text-sm sm:text-base" data-id="element-39">
                    {bonus.target}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};